import { render, staticRenderFns } from "./journal.vue?vue&type=template&id=30bd049c&scoped=true"
import script from "./journal.vue?vue&type=script&lang=js"
export * from "./journal.vue?vue&type=script&lang=js"
import style0 from "./journal.vue?vue&type=style&index=0&id=30bd049c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bd049c",
  null
  
)

export default component.exports